import { AkyosTextOverflow } from 'akyos-animation/animations/textoverflow';

export class Animations {

  constructor() {
    this.init();
  }

  init() {
    const isMobile = window.innerWidth < 768;
    const elements = document.querySelectorAll('[akyos-animation-text-overflow]');

    if (elements.length > 0) {
        elements.forEach(element => {
            new AkyosTextOverflow(element, {
                from: 'down',
                delay: isMobile ? 0 : 0.3,
                duration: isMobile ? 0.5 : 1.2,
            });
        });
    }

  }
}